import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { CommonService } from 'src/app/services/common/common.service';
import { CompanyUserConstant } from 'src/app/constants/label-constants';

@Component({
  selector: 'app-company-user-view',
  templateUrl: './company-user-view.component.html',
  styleUrls: ['./company-user-view.component.scss']
})
export class CompanyUserViewComponent {
  AdminRoleList: any = [];
  userId: number = 0;
  commonConstant: any = [];
  CompanyUserConstant: any = [];
  flag: boolean = false;

  constructor(
    private CommonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    public modalService: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.commonConstant = CommonConstant;
    this.CompanyUserConstant = CompanyUserConstant;
    this.getUserDetail(this.userId);
  }

  getUserDetail(userId: number) {
    const apiUrl = this.apiUrl.apiUrl.companyUser.GetCompanyById.replace("{id}", userId.toString());
    this.spinner.show();
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.AdminRoleList = data.data[0];
        this.spinner.hide();
        this.flag = true;
      },
      error: (err) => {
        console.log('getGetUserById-Error', err);
      }
    });
  }
}
